<p-toast></p-toast>
<p-confirmDialog [style]="{ width: '32rem' }"></p-confirmDialog>

<!-- Un solo overlay reutilizado para toda la ayuda contextual -->
<p-overlayPanel #ayuda [style]="{ width: '26rem' }" styleClass="ayuda-overlay">
  <div class="ayuda" *ngIf="ayudaActiva as a">
    <h4>{{ a.titulo }}</h4>
    <p class="ayuda__what" [innerHTML]="negritas(a.help.what)"></p>
    <div class="ayuda__row" *ngIf="a.help.where">
      <span class="ayuda__tag">Dónde entra</span>
      <p [innerHTML]="negritas(a.help.where)"></p>
    </div>
    <div class="ayuda__row" *ngIf="a.help.example">
      <span class="ayuda__tag">Ejemplo</span>
      <p>{{ a.help.example }}</p>
    </div>
    <div class="ayuda__row ayuda__row--effect" *ngIf="a.help.effect">
      <span class="ayuda__tag">Si lo cambias</span>
      <p>{{ a.help.effect }}</p>
    </div>
    <!-- El enlace va como <a routerLink> de verdad, NUNCA dentro del texto de ayuda: ese pasa por
         `negritas()` con [innerHTML] sin sanitizar, y solo es seguro porque su fuente es una
         constante del código. -->
    <a
      class="ayuda__doc"
      *ngIf="a.docAnchor"
      [routerLink]="['/documentation', manualSlug]"
      [fragment]="a.docAnchor"
      (click)="irAlManual(ayuda)"
    >
      <i class="fa-solid fa-book-open"></i> Leer más en el manual
    </a>
  </div>
</p-overlayPanel>

<div class="page" *ngIf="!cargando && !errorCarga; else estadoCarga">
  <!-- Header -->
  <div class="header-card">
    <div class="header-card__left">
      <i class="fa-solid fa-sliders"></i>
      <div>
        <h1>{{ esNueva ? 'Nueva versión' : config?.name }}</h1>
        <p class="sub">
          <ng-container *ngIf="config">Versión {{ config.version }}<span *ngIf="config.derivedFromVersion"> · derivada de v{{ config.derivedFromVersion }}</span></ng-container>
          <ng-container *ngIf="!config">Sin versión previa: se parte de los valores de fábrica</ng-container>
        </p>
      </div>
      <p-tag *ngIf="config && !esNueva" [value]="etiquetaEstado(config.status)" [severity]="severidadEstado(config.status)"></p-tag>
      <span class="chip-cambios" *ngIf="totalModificados > 0" [pTooltip]="'Campos que difieren de la versión ' + (baseVersion ? 'v' + baseVersion : 'base')" tooltipPosition="bottom">
        <i class="fa-solid fa-pen"></i> {{ totalModificados }} {{ totalModificados === 1 ? 'cambio' : 'cambios' }}
      </span>
    </div>
    <div class="header-card__actions">
      <button pButton type="button" class="p-button-text" icon="fa-solid fa-circle-question" label="¿Cómo funciona?" (click)="mostrarComoFunciona = true"></button>
      <button pButton type="button" class="p-button-text" icon="fa-solid fa-arrow-left" label="Volver" (click)="volver()"></button>
      <button pButton type="button" class="p-button-outlined" icon="fa-solid fa-copy" label="Duplicar como borrador" *ngIf="readonly" (click)="duplicar()"></button>
    </div>
  </div>

  <!-- Solo lectura -->
  <div class="banner banner--orange" *ngIf="readonly">
    <i class="fa-solid fa-lock"></i>
    <div>
      <strong>Esta versión no se edita.</strong>
      Está {{ config?.status === 'active' ? 'activa' : 'archivada' }} y hay verificaciones que la citan: cambiarla les reescribiría el pasado.
      Para ajustar algo, duplícala como borrador.<ng-container *ngIf="config && config.status === 'archived'"> Para revertir a estos valores tal cual, usa «Volver a esta versión».</ng-container>
    </div>
  </div>

  <!-- Borrador local. NUNCA se restaura solo: aplicarlo en silencio enseñaría números distintos de
       los que tiene el servidor sin que el usuario lo note, y estos números fijan precios. -->
  <div class="banner banner--draft" *ngIf="borradorPendiente">
    <i class="fa-solid fa-clock-rotate-left"></i>
    <div>
      <strong>Tienes cambios sin guardar</strong> de {{ antiguedadBorrador() }}. La pantalla los guardó sola cuando saliste.
    </div>
    <div class="banner__acciones">
      <button pButton type="button" class="p-button-sm" label="Restaurar" (click)="restaurarBorrador()"></button>
      <button pButton type="button" class="p-button-sm p-button-text" label="Descartar" (click)="descartarBorrador()"></button>
    </div>
  </div>

  <!-- Campos vacíos -->
  <div class="banner banner--danger" *ngIf="camposVacios.length">
    <i class="fa-solid fa-circle-exclamation"></i>
    <div>
      <strong>{{ camposVacios.length === 1 ? 'Hay un campo sin valor' : 'Hay ' + camposVacios.length + ' campos sin valor' }}.</strong>
      No se puede guardar ni simular hasta llenarlos. Cada uno tiene un botón <i class="fa-solid fa-rotate-left"></i> para devolverlo a su valor anterior.
      <div class="banner__list">
        <button *ngFor="let f of camposVacios" pButton type="button" class="p-button-text p-button-sm p-button-danger"
                [label]="f.label" icon="fa-solid fa-rotate-left" (click)="restaurar(f)"></button>
      </div>
    </div>
  </div>

  <div class="split">
    <!-- ── Columna del formulario ─────────────────────────────────────────── -->
    <div class="split__form">
      <!-- Identidad -->
      <div class="info-card">
        <div class="card-header"><i class="fa-solid fa-tag"></i><h3>Identidad de la versión</h3></div>
        <div class="card-content">
          <div class="grid-2">
            <div class="field field-flex">
              <label>Nombre</label>
              <input pInputText type="text" [(ngModel)]="nombre" (ngModelChange)="marcarCambio()" [disabled]="readonly" placeholder="Ej. Tasas Q3 2026" />
            </div>
            <div class="field field-flex">
              <label>Descripción</label>
              <input pInputText type="text" [(ngModel)]="descripcion" (ngModelChange)="marcarCambio()" [disabled]="readonly" placeholder="Contexto opcional" />
            </div>
          </div>
          <div class="field field-flex">
            <label>Motivo del cambio <span class="req">obligatorio</span></label>
            <textarea pInputTextarea rows="2" [(ngModel)]="motivo" (ngModelChange)="marcarCambio()" [disabled]="readonly"
                      placeholder="Por qué se crea esta versión. Sin motivo, la configuración no es auditable."></textarea>
          </div>
        </div>
      </div>

      <!-- Bloques del esquema -->
      <div class="info-card" *ngFor="let b of schema; let i = index">
        <div class="card-header">
          <span class="paso">{{ i + 1 }}</span>
          <i [class]="b.icon"></i>
          <h3>{{ b.label }}</h3>
          <button pButton type="button" class="p-button-text p-button-sm ayuda-btn" icon="fa-solid fa-circle-question"
                  (click)="abrirAyudaBloque($event, b, ayuda)" pTooltip="Qué hace este bloque" tooltipPosition="left"></button>
        </div>
        <div class="card-content">
          <p class="block-hint">{{ b.hint }}</p>

          <!-- Créditos del proveedor de respaldo. Solo en su bloque: es dato de proveedor, no del cálculo. -->
          <div class="creditos" *ngIf="b.key === 'providers'" [class.creditos--alerta]="reservaBloqueaElRespaldo" [class.creditos--muda]="creditosNoDisponibles">
            <div class="creditos__head">
              <i class="fa-solid fa-wallet"></i>
              <h4>Créditos de Ekatena</h4>
              <span class="creditos__org" *ngIf="creditos?.organizationName">{{ creditos?.organizationName }}</span>
              <button pButton type="button" class="p-button-text p-button-sm" icon="fa-solid fa-rotate"
                      [loading]="creditosCargando" (click)="cargarCreditos(true)"
                      pTooltip="Volver a consultarle el saldo a Ekatena" tooltipPosition="left"></button>
            </div>

            <ng-container *ngIf="creditos?.available; else sinCreditos">
              <div class="creditos__cifras">
                <div class="cifra">
                  <span class="cifra__val">{{ creditos?.balance | number }}</span>
                  <span class="cifra__lbl">créditos disponibles</span>
                </div>
                <div class="cifra" *ngIf="consultasQueAlcanzan !== null">
                  <span class="cifra__val">{{ consultasQueAlcanzan }}</span>
                  <span class="cifra__lbl">consultas que alcanzan</span>
                </div>
                <div class="cifra" *ngIf="consultasAntesDeLaReserva !== null">
                  <span class="cifra__val">{{ consultasAntesDeLaReserva }}</span>
                  <span class="cifra__lbl">antes de tocar la reserva</span>
                </div>
                <div class="cifra" *ngIf="creditos?.preVerifications !== null">
                  <span class="cifra__val">{{ creditos?.preVerifications }}</span>
                  <span class="cifra__lbl">pre-verificaciones</span>
                </div>
                <div class="cifra" *ngIf="creditos?.liveScores !== null">
                  <span class="cifra__val">{{ creditos?.liveScores }}</span>
                  <span class="cifra__lbl">reportes en seguimiento</span>
                </div>
              </div>

              <!-- El aviso que justifica toda la tarjeta: la política puesta deja al respaldo sin margen. -->
              <p class="creditos__alerta" *ngIf="reservaBloqueaElRespaldo">
                <i class="fa-solid fa-triangle-exclamation"></i>
                Con la reserva actual el respaldo <strong>no se dispararía ni una vez</strong>. O baja la reserva, o hay que comprar créditos: encender el interruptor no serviría de nada.
              </p>
              <p class="creditos__nota">
                Leído {{ creditos?.checkedAt | date: 'dd/MM/yyyy HH:mm' }}. Se relee cada cinco minutos; el botón lo fuerza.
              </p>
            </ng-container>

            <ng-template #sinCreditos>
              <p class="creditos__nota">{{ creditosNoDisponibles }}</p>
            </ng-template>
          </div>

          <!-- Grupos de campos escalares -->
          <div class="grupo" *ngFor="let g of b.groups">
            <div class="grupo__head" *ngIf="g.label">
              <h4>{{ g.label }}</h4>
              <p *ngIf="g.hint">{{ g.hint }}</p>
            </div>

            <!-- Fórmula viva: se rearma con cada cambio -->
            <div class="formula" *ngIf="g.formula">
              <code>{{ formulaResuelta(g.formula) }}</code>
            </div>

            <!-- Interruptores: cada uno con el aviso de qué cambia, siempre visible -->
            <div class="interruptores" *ngIf="g.fields.length && g.fields[0].kind === 'switch'">
              <div class="interruptor" *ngFor="let f of g.fields" [class.interruptor--on]="interruptor(f.path)">
                <div class="interruptor__head">
                  <p-inputSwitch [ngModel]="interruptor(f.path)" (ngModelChange)="setInterruptor(f.path, $event)" [disabled]="readonly"></p-inputSwitch>
                  <div>
                    <h5>
                      {{ f.label }}
                      <span class="badge-estado" [class.on]="interruptor(f.path)">{{ interruptor(f.path) ? 'encendido' : 'apagado' }}</span>
                      <span class="badge-estado mod" *ngIf="modificado(f.path)">modificado</span>
                    </h5>
                    <p>{{ f.help.what }}</p>
                  </div>
                  <button pButton type="button" class="p-button-text p-button-sm ayuda-btn"
                          icon="fa-solid fa-circle-question" (click)="abrirAyuda($event, f.label, f.help, ayuda, f.docAnchor || b.docAnchor)"></button>
                </div>
                <div class="interruptor__aviso" [class.aviso--on]="interruptor(f.path)">
                  <i class="fa-solid" [ngClass]="interruptor(f.path) ? 'fa-toggle-on' : 'fa-toggle-off'"></i>
                  <span>{{ interruptor(f.path) ? f.onWarning : f.offWarning }}</span>
                </div>
                <div class="interruptor__contrario">
                  <i class="fa-solid fa-arrow-right-arrow-left"></i>
                  <span><strong>Si lo {{ interruptor(f.path) ? 'apagas' : 'enciendes' }}:</strong> {{ interruptor(f.path) ? f.offWarning : f.onWarning }}</span>
                </div>
              </div>
              <div class="interruptores__cta">
                <i class="fa-solid fa-flask"></i>
                <span>Antes de activar cualquiera de estos, usa <strong>Simular sobre cartera real</strong>: te dice, cliente por cliente, cuánto cambiaría su oferta.</span>
              </div>
            </div>

            <div class="campos" *ngIf="!g.fields.length || g.fields[0].kind !== 'switch'">
              <div class="field" *ngFor="let f of g.fields"
                   [class.field--changed]="modificado(f.path)" [class.field--empty]="vacio(f.path)">
                <label>
                  <span class="lbl">{{ f.label }}</span>
                  <button pButton type="button" class="p-button-text p-button-sm ayuda-btn"
                          icon="fa-solid fa-circle-question" (click)="abrirAyuda($event, f.label, f.help, ayuda, f.docAnchor || b.docAnchor)"></button>
                  <i class="fa-solid fa-triangle-exclamation warn" *ngIf="f.danger" [pTooltip]="f.danger" tooltipPosition="top"></i>
                </label>
                <div class="input-row">
                  <p-inputNumber [ngModel]="valor(f.path)" (ngModelChange)="setValor(f.path, $event)"
                                 [disabled]="readonly" [min]="rango(f.path)?.min" [max]="rango(f.path)?.max"
                                 [minFractionDigits]="f.decimals" [maxFractionDigits]="f.decimals"
                                 [suffix]="f.unit ? ' ' + f.unit : ''"></p-inputNumber>
                  <button pButton type="button" class="p-button-text p-button-sm restore" icon="fa-solid fa-rotate-left"
                          *ngIf="!readonly && (vacio(f.path) || modificado(f.path))" (click)="restaurar(f)"
                          pTooltip="Volver al valor anterior" tooltipPosition="left"></button>
                </div>
                <small class="field-error" *ngIf="vacio(f.path)">Sin valor</small>
              </div>
            </div>
          </div>

          <div class="tramos" *ngIf="b.tierGroups?.length">
            <app-config-tier-editor *ngFor="let g of b.tierGroups"
              [label]="g.label" [hint]="g.hint"
              [thresholdLabel]="g.thresholdLabel" [thresholdUnit]="g.thresholdUnit || ''" [thresholdStep]="g.thresholdStep || 1"
              [valueLabel]="g.valueLabel" [valueUnit]="g.valueUnit || ''" [valueStep]="g.valueStep || 0.01"
              [mode]="g.mode || 'numeric'" [readonly]="readonly"
              [tiers]="tiersDe(g.path)" (tiersChange)="setTiers(g.path, $event)"
              (helpRequested)="abrirAyuda($event, g.label, g.help, ayuda, b.docAnchor)"></app-config-tier-editor>
          </div>

          <div class="field field-flex grade-default" *ngIf="b.key === 'grades' && params">
            <label><span class="lbl">Grade por defecto</span></label>
            <input pInputText type="text" maxlength="2" [(ngModel)]="params.grades.defaultGrade" [disabled]="readonly" />
          </div>
        </div>
      </div>
    </div>

    <!-- ── Columna de la vista previa ─────────────────────────────────────── -->
    <aside class="split__preview">
      <div class="info-card sticky">
        <div class="card-header">
          <i class="fa-solid fa-eye"></i>
          <h3>Qué le pasa a un cliente</h3>
          <i class="fa-solid fa-circle-notch fa-spin cargando" *ngIf="previewCargando"></i>
        </div>
        <div class="card-content">
          <p class="block-hint compacta">
            Cinco perfiles de ejemplo, recalculados con lo que tienes en pantalla. Pasa el cursor sobre un nombre
            para ver de qué empresa se trata.
          </p>

          <div class="perfil" *ngFor="let p of preview">
            <div class="perfil__head">
              <strong [pTooltip]="p.description" tooltipPosition="left" [tooltipStyleClass]="'perfil-tip'">{{ p.label }}</strong>
              <span class="perfil__grade" [attr.data-grade]="p.grade">{{ p.grade }}</span>
            </div>
            <div class="perfil__ofertas">
              <div class="oferta oferta--max">
                <span class="oferta__lbl">Máxima</span>
                <span class="oferta__amt">{{ p.maxOffer.amount | currency:'MXN':'symbol-narrow':'1.0-0' }}</span>
                <span class="oferta__meta">{{ p.maxOffer.interestRate }}% · {{ p.maxOffer.termMonths }} meses</span>
              </div>
              <div class="oferta">
                <span class="oferta__lbl">Conservadora</span>
                <span class="oferta__amt">{{ p.minOffer.amount | currency:'MXN':'symbol-narrow':'1.0-0' }}</span>
                <span class="oferta__meta">{{ p.minOffer.interestRate }}% · {{ p.minOffer.termMonths }} meses</span>
              </div>
            </div>
            <div class="perfil__factores">
              <span pTooltip="Capacidad base antes de los multiplicadores" tooltipPosition="top">
                base {{ p.baseCapacity | currency:'MXN':'symbol-narrow':'1.0-0' }}
              </span>
              <span [class.malo]="p.factors.composite < 0.8" pTooltip="Producto de los seis multiplicadores de riesgo" tooltipPosition="top">
                × {{ p.factors.composite | number:'1.2-2' }}
              </span>
            </div>
          </div>

          <div class="preview-vacio" *ngIf="!preview.length && !previewCargando">
            <i class="fa-solid fa-eye-slash"></i>
            <p *ngIf="camposVacios.length">Llena los campos vacíos para ver el efecto.</p>
            <p *ngIf="!camposVacios.length">Sin vista previa disponible.</p>
          </div>
        </div>
      </div>
    </aside>
  </div>

  <!-- Footer -->
  <div class="footer-actions">
    <button pButton type="button" class="p-button-outlined" icon="fa-solid fa-flask" label="Simular sobre cartera real"
            (click)="simular()" [disabled]="!params || camposVacios.length > 0"></button>
    <span class="spacer"></span>
    <button pButton type="button" class="p-button-outlined" icon="fa-solid fa-floppy-disk"
            [label]="esNueva ? 'Guardar borrador' : 'Guardar cambios'" *ngIf="editable"
            (click)="guardar()" [loading]="guardando" [disabled]="camposVacios.length > 0"></button>
    <button pButton type="button" class="p-button-success" icon="fa-solid fa-circle-check"
            [label]="config && config.status === 'archived' ? 'Volver a esta versión' : 'Activar'"
            *ngIf="config && config.status !== 'active' && !esNueva" (click)="activar()"></button>
  </div>
</div>

<!-- Cargando / error -->
<ng-template #estadoCarga>
  <div class="page">
    <ng-container *ngIf="cargando">
      <p-skeleton height="5rem" styleClass="mb-3"></p-skeleton>
      <p-skeleton height="14rem" styleClass="mb-3"></p-skeleton>
      <p-skeleton height="14rem"></p-skeleton>
    </ng-container>
    <div class="estado-error" *ngIf="errorCarga">
      <i class="fa-solid fa-triangle-exclamation"></i>
      <h3>No se pudo cargar la configuración</h3>
      <p>{{ errorCarga }}</p>
      <div class="estado-error__acciones">
        <button pButton type="button" class="p-button-outlined" icon="fa-solid fa-rotate-right" label="Reintentar" (click)="reintentar()"></button>
        <button pButton type="button" class="p-button-text" icon="fa-solid fa-arrow-left" label="Volver" (click)="volver()"></button>
      </div>
    </div>
  </div>
</ng-template>

<!-- ¿Cómo funciona? -->
<p-dialog header="Cómo se calcula una oferta" [(visible)]="mostrarComoFunciona" [modal]="true"
          [style]="{ width: '52rem', maxWidth: '95vw' }" [contentStyle]="{ maxHeight: '72vh', overflowY: 'auto' }"
          [draggable]="false" [resizable]="false" styleClass="como-funciona-dialog">
  <div class="como">
    <p class="como__intro">
      Cada vez que se corre el análisis fiscal de un cliente, el reporte del SAT pasa por estos pasos <strong>en este orden</strong>.
      Los bloques del formulario están puestos en la misma secuencia, así que leerlo de arriba a abajo es leer el algoritmo.
    </p>
    <ol class="como__pasos">
      <li *ngFor="let b of schema; let i = index">
        <span class="como__num">{{ i + 1 }}</span>
        <div>
          <h4><i [class]="b.icon"></i> {{ b.label }}</h4>
          <p [innerHTML]="negritas(b.help)"></p>
          <a class="como__doc" *ngIf="b.docAnchor" [routerLink]="['/documentation', manualSlug]" [fragment]="b.docAnchor"
             (click)="mostrarComoFunciona = false">Ver en el manual</a>
        </div>
      </li>
    </ol>
    <div class="banner banner--orange">
      <i class="fa-solid fa-lightbulb"></i>
      <div>
        Los cambios <strong>no afectan a las verificaciones ya emitidas</strong>: cada una guarda con qué versión se calculó.
        Solo las ofertas nuevas usan la configuración activa. Y siempre se puede volver a una versión anterior con un clic.
      </div>
    </div>
    <a class="como__manual" [routerLink]="['/documentation', manualSlug]" (click)="mostrarComoFunciona = false">
      <i class="fa-solid fa-book-open"></i> Manual completo del análisis fiscal
    </a>
  </div>
</p-dialog>

<!-- Simulación -->
<p-dialog header="Impacto sobre la cartera real" [(visible)]="mostrarSimulacion" [modal]="true"
          [style]="{ width: '80rem', maxWidth: '95vw' }" [draggable]="false" [resizable]="false">
  <div class="sim">
    <p class="sim__intro">
      Se recalculan verificaciones ya emitidas con los parámetros que tienes en pantalla. <strong>No se guarda nada</strong>
      y no se consulta a Syntage: se usa el mismo reporte con el que se calculó cada oferta original.
    </p>
    <p class="sim__intro" *ngIf="simulacion as s0">
      La columna <strong>actual</strong> también se recalcula, con la configuración activa (v{{ s0.baselineVersion }}) y sobre
      las mismas señales. Así el Δ mide únicamente el efecto de tu cambio. La columna <em>emitida</em> es lo que se le dio al
      cliente en su momento; puede diferir porque el reporte guardado no conserva todos los campos del original.
    </p>

    <div class="sim__loading" *ngIf="simulando">
      <p-progressSpinner strokeWidth="4" [style]="{ width: '2.5rem', height: '2.5rem' }"></p-progressSpinner>
      <span>Recalculando…</span>
    </div>

    <ng-container *ngIf="!simulando && simulacion as s">
      <div class="sim__kpis">
        <div class="kpi"><span class="kpi-val">{{ s.summary.count }}</span><span class="kpi-lbl">Verificaciones</span></div>
        <div class="kpi"><span class="kpi-val" [ngClass]="claseDelta(s.summary.avgAmountDeltaPct)">{{ s.summary.avgAmountDeltaPct > 0 ? '+' : '' }}{{ s.summary.avgAmountDeltaPct }}%</span><span class="kpi-lbl">Δ monto promedio</span></div>
        <div class="kpi"><span class="kpi-val" [ngClass]="claseDelta(s.summary.avgRateDeltaPts)">{{ s.summary.avgRateDeltaPts > 0 ? '+' : '' }}{{ s.summary.avgRateDeltaPts }}</span><span class="kpi-lbl">Δ tasa (pts)</span></div>
        <div class="kpi"><span class="kpi-val up">{{ s.summary.countIncreased }}</span><span class="kpi-lbl">Suben</span></div>
        <div class="kpi"><span class="kpi-val down">{{ s.summary.countDecreased }}</span><span class="kpi-lbl">Bajan</span></div>
        <div class="kpi"><span class="kpi-val">{{ s.summary.countUnchanged }}</span><span class="kpi-lbl">Sin cambio</span></div>
        <div class="kpi" data-test="sim-at-ceiling">
          <span class="kpi-val" [class.warn-val]="s.summary.atCeilingWarning">{{ s.summary.countAtCeiling ?? 0 }}</span>
          <span class="kpi-lbl">Conservadora en el techo (hoy {{ s.summary.baselineCountAtCeiling ?? 0 }})</span>
        </div>
      </div>

      <!-- B-056: el aviso no bloquea la activación. Dice qué parámetro mover porque el reflejo natural
           (subir el techo) acerca las dos ofertas en vez de arreglar el piso. -->
      <div class="banner banner--orange compacto" *ngIf="s.summary.atCeilingWarning" data-test="sim-ceiling-warning">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <div>
          En {{ s.summary.countAtCeiling }} de {{ s.summary.count }} análisis la oferta conservadora queda pegada al techo: el piso
          sobre ingreso está alto para la capacidad que configuraste. Antes de activar, baja el <strong>Piso sobre ingreso</strong>
          (bloque Oferta conservadora); subir el techo solo acerca las dos ofertas.
        </div>
      </div>

      <div class="banner banner--orange compacto" *ngIf="s.skipped">
        <i class="fa-solid fa-circle-info"></i>
        <div>Se omitieron {{ s.skipped }} verificaciones sin oferta previa con la que comparar.</div>
      </div>

      <p-table [value]="s.rows" [rows]="12" [paginator]="s.rows.length > 12" styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="24rem">
        <ng-template pTemplate="header">
          <tr>
            <th>RFC</th><th>Score</th>
            <th>Monto actual</th><th>Monto nuevo</th><th>Δ</th>
            <th>Tasa actual</th><th>Tasa nueva</th><th>Δ pts</th>
            <th class="tenue">Emitida</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-r>
          <tr>
            <td class="mono">{{ r.rfc }}</td>
            <td>{{ r.score }}</td>
            <td class="mono">{{ r.current.amount | currency:'MXN':'symbol-narrow':'1.0-0' }}</td>
            <!-- El valor NUEVO toma el color de su propia Δ, no uno propio: así la pareja
                 «cuánto queda / cuánto cambió» se lee junta. El valor ACTUAL se queda en negro
                 porque es la referencia contra la que se compara, no algo que se movió. -->
            <td class="mono" [ngClass]="claseValor(r.delta.amountPct)">{{ r.candidate.amount | currency:'MXN':'symbol-narrow':'1.0-0' }}</td>
            <td class="mono" [ngClass]="claseDelta(r.delta.amountPct)">{{ r.delta.amountPct > 0 ? '+' : '' }}{{ r.delta.amountPct }}%</td>
            <td class="mono">{{ r.current.rate }}%</td>
            <td class="mono" [ngClass]="claseValor(r.delta.ratePts)">{{ r.candidate.rate }}%</td>
            <td class="mono" [ngClass]="claseDelta(r.delta.ratePts)">{{ r.delta.ratePts > 0 ? '+' : '' }}{{ r.delta.ratePts }}</td>
            <td class="mono tenue">{{ r.stored ? (r.stored.amount | currency:'MXN':'symbol-narrow':'1.0-0') : '—' }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr><td colspan="9" class="vacio">No hay verificaciones con las que comparar todavía.</td></tr>
        </ng-template>
      </p-table>
    </ng-container>
  </div>
</p-dialog>
